import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { redirectToLogin } from './redirect-to-login';

/**
 * Shown by `AuthenticationGuard` when there is no `jwt` cookie, the
 * cookie is malformed, or the backend invalidated the session (401).
 * Replaces the previous automatic redirect to `LOGIN_URL` — by keeping
 * the user on this screen, devs can paste a fresh `jwt` cookie in
 * DevTools and refresh, which is how stage testing works today.
 */
export const NoJwtScreen = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      py: 6,
    }}
  >
    <Card sx={{ maxWidth: 480, width: '100%' }}>
      <CardContent>
        <Stack spacing={2} alignItems="flex-start">
          <Box
            sx={{
              bgcolor: 'primary.light',
              color: 'primary.dark',
              width: 44,
              height: 44,
              borderRadius: 999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LockOutlinedIcon />
          </Box>
          <Typography variant="h5" component="h1">
            Sesión requerida
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Para usar HSM Admin necesitás una sesión de Cliengo válida en este
            navegador. Iniciá sesión y volvé a esta pantalla.
          </Typography>
          <Button
            variant="contained"
            onClick={redirectToLogin}
            sx={{ alignSelf: 'flex-start' }}
          >
            Iniciar sesión
          </Button>
        </Stack>
      </CardContent>
    </Card>
  </Box>
);
